import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { MetricAreaModel } from '../components/common/models/metric-area.model';


export interface MetadataMetricAreaStateModel {
  categories: MetricAreaModel[];
}

export class MetadataMetricAreaLoaded {
  static readonly type = '[MetadataMetricArea] loaded';

  constructor(public categories: MetricAreaModel[]) {
  }
}

@State<MetadataMetricAreaStateModel>({
  name: 'metadataMetricAreaState',
  defaults: { categories: [] }
})
@Injectable()
export class MetadataMetricAreaState {

  constructor() {
  }

  @Selector()
  static categories(state: MetadataMetricAreaStateModel) {
    return state.categories;
  }

  @Action(MetadataMetricAreaLoaded)
  loaded(ctx: StateContext<MetadataMetricAreaStateModel>, action: MetadataMetricAreaLoaded) {

    ctx.patchState({
      categories: action.categories
    });

  }
}
